<template>
  <div class="learning-map" :class="BOOL_SENIOR || BOOL_SENIOR_EMPLOYEE ? 'cur' : ''"
       v-if="BOOL_SENIOR || BOOL_SENIOR_EMPLOYEE">
    <!-- <div v-if="BOOL_SENIOR_EMPLOYEE"> -->
    <div class="bg-img" v-if="mapItemText === 'dpt'">
      <img src="../../../assets/images/home/bg_Department@2x.png" class="learning-bg" alt="">
      <!-- <img src="@/assets/images/home/bg_map@2x (1).png" class="learning-bg" alt=""> -->
    </div>
    <!-- <div class="bg-img" v-if="mapItemText === 'learn'">
      <img src="@/assets/images/home/bg_map_normal@2x.png" class="learning-bg" alt="">
    </div> -->
    <div class="learning-txt learning-txt2" v-if="mapItemText === 'dpt'">
      <div class="learn-flex">
        <img src="../../../assets/images/home/icon_Department@2x.png" class="learning-img" alt="">
        <div class="txt">科室总览</div>
      </div>
      <div class="learn-flex learn-flex2" @click="handleClickItems('learn')">
      </div>
      <!-- <div class="learn-flex learn-flex2" @click="handleClickItems('learn')">
        <img src="@/assets/images/home/icon_map_ed@2x.png" class="learning-img" alt="">
        <div class="txt">学习地图</div>
      </div> -->
    </div>
    <!-- <div class="learning-txt learning-txt2" v-if="mapItemText === 'learn'">
      <div class="learn-flex learn-flex2" @click="handleClickItems('dpt')">
        <img src="@/assets/images/home/icon_Department_ed@2x.png" class="learning-img" alt="">
        <div class="txt">科室总览</div>
      </div>
      <div class="learn-flex">
        <img src="@/assets/images/home/icon_map@2x.png" class="learning-img" alt="">
        <div class="txt">学习地图</div>
      </div>
    </div> -->
    <!-- <div class="tab-txt" v-if="mapItemText === 'dpt'" @click="handleClickItems('learn')">学习地图</div>
    <div class="tab-txt tab-txt2" v-if="mapItemText === 'learn'" @click="handleClickItems('dpt')">科室总览</div> -->
    <!-- </div> -->
    <!-- <div v-else>
      <div class="bg-img" v-if="BOOL_GOAL">
        <img src="@/assets/images/home/bg_map@2x.png" class="learning-bg" alt="">
      </div>
      <div class="bg-img" v-if="BOOL_SENIOR">
        <img src="@/assets/images/home/bg_Department_normal@2x.png" class="learning-bg" alt="">
      </div>
      <div class="learning-txt" v-if="mapItemText === 'dpt' || BOOL_SENIOR">
        <img src="@/assets/images/home/icon_Department@2x.png" class="learning-img" alt="">
        <div class="txt">科室总览</div>
      </div>
      <div class="learning-txt" :class="mapItemText === 'learn' ? 'cur' : ''" v-if="mapItemText === 'learn' || BOOL_GOAL">
        <img src="@/assets/images/home/icon_map@2x.png" class="learning-img" alt="">
        <div class="txt">学习地图</div>
      </div>
    </div> -->
    <div class="click-con" v-show="mapItemText === 'dpt'">
      <div v-track="{ functionName: '科室总览' }" @click="handleClick('dpt')" class="dpt-img-box">
        <img src="../../../assets/images/home/bottom_icon_Department@2x.png" class="learning-img2 dpt-img" alt="">
        <img src="../../../assets/images/home/bottom_icon_Department_right@2x.png" class="learning-img2 dpt-img1"  alt="">
      </div>
      <div class="dpt-btm">
        <div class="dpt-items">
          <div class="label">{{ totalData && totalData.replay }}</div>
          <div class="val">病例复盘</div>
        </div>
        <div class="dpt-items">
          <div class="label">{{ totalData && totalData.practice }}</div>
          <div class="val">模拟器练习</div>
        </div>
        <div class="dpt-items">
          <div class="label">{{ totalData && totalData.learnTime }}</div>
          <div class="val">学习时长</div>
        </div>
        <div class="dpt-items">
          <div class="label">{{ totalData && totalData.score }}</div>
          <div class="val">AIFV评分</div>
        </div>
      </div>
    </div>
    <!-- <div class="click-con" v-show="mapItemText === 'learn'">
      <img src="@/assets/images/home/bottom_icon_map@2x.png" class="learning-img2" alt="" v-track="{ functionName: '学习地图' }"
        @click="handleClick('learn')">
      <img src="@/assets/images/home/image_map@2x.png" class="learning-img3" alt="">
      <div class="learning-btm" v-if="evaluationCriteria || courseName" v-track="{ functionName: '首页课程学习' }"
        @click.stop="handleClick('toStudy')">
        <div class="label">
          <span class="label-txt1">{{ evaluationCriteria }}</span>
          |
          <span class="label-txt1 label-txt2">{{ courseName }}</span>
        </div>
        <div class="val">去学习</div>
      </div>
    </div> -->
  </div>
</template>
<script>
import { BOOL_EMPLOYEE, BOOL_NON_GOAL, BOOL_GOAL, BOOL_NON_EP, BOOL_SENIOR, BOOL_SENIOR_EMPLOYEE } from '@/utils/configRoles'
import { getDepDevelop } from '@/api/departmentOverview'
import { checkObject } from '@/utils/util'
import { getJourneyReport } from '@/api/growthJourney.js'
import {isScorm} from '../../../api/scorm'
export default {
  data () {
    return {
      mapItemText: '',
      BOOL_EMPLOYEE,
      BOOL_NON_GOAL,
      BOOL_GOAL,
      BOOL_NON_EP,
      BOOL_SENIOR,
      BOOL_SENIOR_EMPLOYEE,
      totalData: {
        replay: '0',
        practice: '0',
        learnTime: '0',
        score: '0',
        percent: '0'
      },
      evaluationCriteria: '', // 旅程阶段的过关标准
      courseName: '', // 最新未完成或进行中的课程名称
    }
  },
  mounted () {
    console.log(this.BOOL_SENIOR, this.BOOL_SENIOR_EMPLOYEE, '23')
    if (!this.BOOL_GOAL && !this.BOOL_SENIOR && !this.BOOL_SENIOR_EMPLOYEE) return
    // if (this.BOOL_GOAL) {
    //   this.mapItemText = 'learn'
    // }
    if (this.BOOL_SENIOR || this.BOOL_SENIOR_EMPLOYEE) {
      this.mapItemText = 'dpt'
    }
    if (this.BOOL_GOAL && this.BOOL_SENIOR) {
      this.BOOL_SENIOR_EMPLOYEE = true
    }
    console.log(this.mapItemText)
    if (this.userInfo.multiCode) {
      this.getDepData()
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    handleClickItems (text) {
      this.mapItemText = text
    },
    async handleClick (type) {
      let path = ''
      let query = {}
      if (type === 'learn') {
        path = '/learningMap'
        localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/learningMap`)
      } else if (type === 'dpt') {
        path = '/dptOverview'
        localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/dptOverview`)
      } else if (type === 'toStudy') {
        window.sessionStorage.setItem('entrance', 14)
        localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/courserDetails?courseId=${this.course.courseId}&journeyId=${this.course.journeyId}`)
        query = {
          courseId: this.course.courseId,
          journeyId: this.course.journeyId,
          businessId: this.course.journeyId,
          entrance: '14',
          channel: '14'
        }
        const isscorm = await isScorm(this.course.courseId)
        path = '/courserDetails'
        if (isscorm.data) {
          path = '/scormCourseDetail'
        }
      }
      this.$router.push({path, query})
    },

    getDepData () {
      getJourneyReport({
        multiCode: this.userInfo.multiCode
      }).then(res => {
        if (!res.data) return
        // 获取最新未开始或进行中的旅程
        let curReport = res.data.journeyReports.filter(item => item.learningStatus === '2' || item.learningStatus === '3')[0]
        // 获取最新未开始或进行中的阶段，阶段是倒序排序
        let stagesArr = curReport.stages.filter(item => item.learningStatus === '2' || item.learningStatus === '3')
        let curState = stagesArr[stagesArr.length - 1]
        this.evaluationCriteria = curState.evaluationCriteria
        this.course = curState.stageCourses.filter(item => item.learningStatus === '2' || item.learningStatus === '3')[0]
        this.courseName = curState.stageCourses.filter(item => item.learningStatus === '2' || item.learningStatus === '3')[0].courseName
      }).catch(err => {
        console.log('getDepData err', err)
      })
      getDepDevelop({
        pageNum: 1,
        pageSize: 10,
        multiCode: this.userInfo.multiCode
      })
        .then(res => {
          if (res && res.data) {
            if (checkObject(res.data)) {
              let rData = JSON.parse(JSON.stringify(res.data))
              // 数据统计
              this.totalData.replay = Number(rData.deptCaseReviewCnt).toFixed(0) || 0
              this.totalData.practice = Number(rData.dtptCasePracticeCnt).toFixed(0) || 0
              this.totalData.learnTime = Number(rData.deptLearningDuration).toFixed(1) || 0
              this.totalData.score = Number(rData.deptAifv).toFixed(1) || 0
              this.totalData.percent = Number(rData.deptThanPercent).toFixed(2) || 0
            }
          }
        })
        .catch(err => {
          console.log('getDepData err', err)
        })
    }
  }
}
</script>
<style lang="less" scoped>
.learning-map {
  position: relative;
  width: 348px;
  height: 124px;
  margin-bottom: 10px;

  &.cur {
    height: 133px;
  }

  .learning-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }

  .tab-txt {
    font-size: 14px;
    color: #8D96A3;
    position: absolute;
    top: 6px;
    left: 185px;
    z-index: 1;

    &.tab-txt2 {
      left: 43px;
    }
  }

  .learning-txt {
    display: flex;
    align-items: center;
    position: relative;
    padding-top: 8px;
    padding-left: 21px;
    box-sizing: border-box;
    margin-bottom: 13px;

    &.learning-txt2 {
      padding-left: 0;
    }

    .learn-flex {
      display: flex;
      align-items: center;
      flex: 1;
      justify-content: center;

      &.learn-flex2 {
        .txt {
          color: #000000;

          &::after {
            display: none;
          }
        }
      }
    }

    .learning-img {
      width: 15px;
      height: 15px;
      margin-right: 5px;
      display: block;
    }

    .txt {
      font-size: 14px;
      color: #EB1700;
      line-height: 20px;
      font-weight: 600;
      position: relative;
      z-index: 1;

      &::after {
        position: absolute;
        left: 0;
        bottom: 0px;
        width: 100%;
        height: 5px;
        background: linear-gradient(90.00deg, rgba(235, 23, 0, 0.3),rgba(255, 255, 255, 0) 100%);
        content: '';
        z-index: -1;
      }
    }
  }

  .dpt-img-box {
    display: flex;
    align-items: center;
  }

  .learning-img2 {
    width: 102px;
    display: block;
    margin-bottom: 16px;
    position: relative;
    margin-left: 16px;

    &.dpt-img {
      width: 125px;
      margin-bottom: 12px;
    }
    &.dpt-img1 {
      width: 17px;
      margin-bottom: 12px;
    }
  }

  .learning-img3 {
    position: absolute;
    top: 25px;
    right: 16px;
    width: 86px;
    display: block;
  }

  .learning-btm {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    padding: 0 16px;
    box-sizing: border-box;

    .label {
      font-size: 13px;
      color: #6A7481;
      font-weight: 400;
      line-height: 16px;
      display: flex;

      .label-txt1 {
        display: block;
        width: 130px;
        line-height: 18px;
        max-height: 36px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        -webkit-line-clamp: 2;
        &.label-txt2 {
          margin-left: 6px;
        }
      }
    }

    .val {
      font-size: 13px;
      color: #EB1700;
    }
  }

  .dpt-btm {
    display: flex;
    justify-content: space-between;
    padding: 0 14px;
    box-sizing: border-box;

    .dpt-items {
      display: flex;
      flex-direction: column;
      position: relative;
      align-items: center;

      .label {
        font-size: 16px;
        line-height: 20px;
        color: #EB1700;
        font-weight: 500;
        margin-bottom: 2px;
      }

      .val {
        font-size: 12px;
        color: #564C47;
        line-height: 20px;
      }
    }
  }
}</style>



// WEBPACK FOOTER //
// src/views/home/components/LearnDptTab.vue